import { testimonials } from "@/mocks/home";

const values = [
  { icon: "ri-focus-3-line", title: "专注阅读", desc: "一切设计以阅读体验为先，无弹窗、无打扰，让剧情全程流畅。", color: "text-primary-700 bg-primary-100" },
  { icon: "ri-empathize-line", title: "尊重内容", desc: "坚持高清画质与完整分镜，让每一部韩漫作品都被原汁原味呈现。", color: "text-accent-700 bg-accent-100" },
  { icon: "ri-rocket-line", title: "持续进化", desc: "从加载到翻页再到缩放，韩漫在线不断优化，只为更顺手的体验。", color: "text-secondary-800 bg-secondary-100" },
];

export default function Brand() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-xs font-medium text-primary-700">
              <i className="ri-store-2-line"></i>
              关于韩漫在线
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              为纯粹阅读而生的韩漫平台
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              韩漫在线诞生于一个朴素的愿望：让每一位读者都能在无弹窗、高清、极速加载的环境里，专注享受韩漫带来的快乐。我们相信，好的阅读体验不该被广告和卡顿打乱。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              从翻页、缩放等基础操作到夜间模式、进度同步等贴心细节，韩漫在线的每一项功能都围绕真实阅读场景打磨，致力于成为你手机上最顺手的韩漫阅读伙伴。
            </p>
            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {values.map((v) => (
                <div key={v.title} className="rounded-xl border border-background-200 bg-background-100 p-4">
                  <span className={`flex h-10 w-10 items-center justify-center rounded-lg text-lg ${v.color}`}>
                    <i className={v.icon}></i>
                  </span>
                  <h3 className="mt-3 font-heading text-sm font-semibold text-foreground-950">{v.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-4">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-xl border border-background-200 bg-background-100 p-6">
                <div className="flex items-center gap-1 text-primary-500">
                  {Array.from({ length: t.star }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 font-heading text-sm font-bold text-background-50">
                    {t.name.slice(0, 1)}
                  </span>
                  <div>
                    <div className="text-sm font-medium text-foreground-950">{t.name}</div>
                    <div className="text-xs text-foreground-500">{t.role}</div>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}